<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Log Detail</strong>
            <span class="float-right">Date : {{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_username" v-b-tooltip.hover>Attacker</label><br></b>
                <label for="ph_username" v-b-tooltip.hover v-if="this.model">{{model.remote_addr}}</label>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_username" v-b-tooltip.hover>Target</label><br></b>
                <label for="ph_username" v-b-tooltip.hover v-if="this.model">{{model.target}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_username" v-b-tooltip.hover>Response</label><br></b>
                <b-badge v-if="model.is_block" variant="danger">Block</b-badge>
                <b-badge v-else variant="warning">Detect</b-badge>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_seed" v-b-tooltip.hover>Request</label><br></b>
                <label for="ph_seed" v-b-tooltip.hover>{{model.request}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_seed" v-b-tooltip.hover>Protocol</label><br></b>
                <label for="ph_seed" v-b-tooltip.hover>{{model.protocol}}</label>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_seed" v-b-tooltip.hover>Risk(Severity)</label><br></b>
                <b-badge v-if="model.severity >= 5" variant="danger">CRITICAL</b-badge>
                <b-badge v-else-if="model.severity >= 4" variant="warning">ERROR</b-badge>
                <b-badge v-else-if="model.severity >= 3" variant="warning">WARNING</b-badge>
                <b-badge v-else-if="model.severity >= 2" variant="dark">NOTICE</b-badge>
                <b-badge v-else variant="primary">Normal</b-badge>
              </b-form-group>
            </b-col>
          <!-- // # - CRITICAL severity: Anomaly Score of 5. Mostly generated by the application attack rules (93x and 94x files).
          // # - ERROR severity: Anomaly Score of 4. Generated mostly from outbound leakage rules (95x files).
          // # - WARNING severity: Anomaly Score of 3. Generated mostly by malicious client rules (91x files).
          // # - NOTICE severity: Anomaly Score of 2. Generated mostly by the protocol rules (92x files). -->
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b><label for="ph_seed" v-b-tooltip.hover>URI</label><br></b>
                <label for="ph_seed" v-b-tooltip.hover>{{model.uri}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_seed" v-b-tooltip.hover>Rule ID</label><br></b>
                <pre for="ph_seed" v-b-tooltip.hover>{{model.m_id}}</pre>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_seed" v-b-tooltip.hover>Rule Line</label><br></b>
                <pre for="ph_seed" v-b-tooltip.hover>{{model.m_line}}</pre>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b><label for="ph_seed" v-b-tooltip.hover>Rule File</label><br></b>
                <pre for="ph_seed" v-b-tooltip.hover>{{model.m_file && model.m_file}}</pre>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="12">
              <b-form-group>
                <b><label for="ph_seed" v-b-tooltip.hover>Detect Message</label><br></b>
                <label for="ph_seed" v-b-tooltip.hover>{{model.message}}</label>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b><label for="ph_seed" v-b-tooltip.hover>Headers</label><br></b>
                <pre for="ph_seed" v-b-tooltip.hover>{{model.headers}}</pre>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <center>
            Matched Information
          </center>
          <hr>
          <table v-if="is_error == false" class="table table-sm table-dark">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Message</th>
                <th scope="col">Rule ID</th>
                <th scope="col">Maturity</th>
                <th scope="col">Accuracy</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in (model.message.messages || [])" :key="index">
                <th scope="row">{{index + 1}}</th>
                <th scope="row">{{row.message}}</th>
                <th scope="row">{{row.details.ruleId}}</th>
                <th scope="row">{{row.details.maturity}}</th>
                <th scope="row">{{row.details.accuracy}}</th>
              </tr>
            </tbody>
          </table>
          <b-button size="sm" class="float-right" variant="primary" @click="list">List</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Api } from '@/service';

export default {
  data : () => {
    return {
      model : { message : { messages : [], unique_id : "", time_stamp : "" } },
      is_error : false,
    }
  },
  methods: {
    list() { this.$router.push({ name: 'webcastle_log'}); },
    async get({ id } = this.$route.params) {
      console.log('detect.detail.vue', 'load item', id);
      try {
        let rs = await Api.Manager_Call('webcastle.log', 'detail', { id : id })
        if(rs.error) { return this.$toastr.e("load", "failed"); }
        this.model = Object.assign({}, this.model, rs.body);
        this.model.message = JSON.parse(this.model.message);
        if(!this.model.message.unique_id) { this.is_error = true }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('detect.detail.vue', 'created'); },
  destroyed() { console.log('detect.detail.vue', 'destroyed'); },
  mounted() {
    console.log('detect.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
